module.exports = __webpack_public_path__ + "static/img/csmp08.03e8963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upload/csmp08.png
// module id = tD19
// module chunks = 1